var map = {
	"./burger.svg": 240,
	"./check.svg": 241,
	"./cross.svg": 242,
	"./logo.svg": 243,
	"./mail.svg": 244,
	"./map-marker.svg": 245,
	"./offer-address.svg": 246,
	"./offer-audiences.svg": 247,
	"./offer-type.svg": 248,
	"./phone.svg": 249
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;


//////////////////
// WEBPACK FOOTER
// ./svgs \.svg$
// module id = 117
// module chunks = 1